import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import api from '../api';
import { Skeleton } from 'primereact/skeleton';
import { useSelectedContext } from '../components/SelectedContext';
import { useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from "primereact/toast";
import './style/DataDocScreen.css';
import PreviewFileWindow from "../components/PreviewFileWindow";

const DatabaseView = () => {
    const { selectedDBRow, visibleColumns, setDataToExport, dataToExport, globalFilterFields, globalFilters, setGlobalFilters, setTableData, tableData, setNonFilterData, skelData } = useSelectedContext();
    const [isLoading, setIsLoading] = useState(true);
    const { selectedDocType, selectedDocId } = useParams();
    const [previewVisible, setPreviewVisible] = useState(false);
    const [pdfUrl, setPdfURL] = useState('');
    const [pdfButVis, setPdfButVis] = useState(false);
    const [statuses, setDiams] = useState([]);
    const [diameters, setDiameters] = useState([]);
    const [formattedAll, setFormattedAll] = useState([]);
    const [lastNewData, setLastNewData] = useState(null);
    const [previewTableData, setPreviewTableData] = useState([]);
    const [previewPageNumber, setPreviewPageNum] = useState(1);
    const [previewFileData, setPreviewFile] = useState('');
    const toastBottomLeft = useRef(null);

    useEffect(() => {
        getAllAtts()
    }, []);

    const getAllAtts = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const headers = {
              Authorization: `Bearer ${token}`,
            };
            const response = await api.get(`/mtr/top-mtr-attributes/${parseInt(selectedDocId,10)}`, { headers });
            const responseDiam = await api.get('/mtr/diameter', { headers });
            setDiams(responseDiam.data.map(item => item));
            setDiameters(responseDiam.data.map(item => item + '"'))
            setFormattedAll(formatTopMTR(response.data));
        } catch (error) {
            console.error('Failed to get attributes: ', error);
        }
        finally {
            setIsLoading(false);
        }
    }

    const showMessage = (ref, severity, message, detail) => {
        ref.current.show({ severity: severity, summary: message, detail: detail, life: 3000 });
    };

    useEffect(() => {
        const exampleObject = formattedAll[0];
        let columnHeaders = [];

        if (exampleObject) {
            columnHeaders = Object.keys(exampleObject).filter(key => key !== "id");
        }
        else {
            columnHeaders = []
        }
        
        setNonFilterData(formattedAll);
        setTableData(formattedAll);
        setDataToExport(formattedAll);
        setLastNewData(formattedAll);
        setGlobalFilters(columnHeaders);
    }, [formattedAll]);

    useEffect(() => {
        if (lastNewData && Array.isArray(visibleColumns) && visibleColumns.length > 0) {
            const filteredData = lastNewData.map((item) => {
                const filteredItem = {
                    count: item.count
                };
                for (const col of visibleColumns) {
                  if (item.hasOwnProperty(col.field)) {
                    filteredItem[col.field] = item[col.field];
                  }
                }
                filteredItem.date_created = item.date_created;
                return filteredItem;
            });
            setDataToExport(filteredData);
        }

    }, [visibleColumns]);

    const textEditor = (options) => {
        const { value } = options;
        const defaultValue = value !== null && value !== undefined ? value : '';

        return (
            <InputText
                style={{ width: '100%' }}
                type="text"
                value={defaultValue}
                onChange={(e) => options.editorCallback(e.target.value)}
            />
        );
    };

    const dropdownEditor = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={statuses}
                className="md:w-10rem"
                onChange={(e) => options.editorCallback(e.value)}
                placeholder="Select a Diameter"
            />
        );
    };

    const dateEditor = (options) => {
        const handleDateChange = (e) => {
            let selectedDate = new Date(e.value);
            selectedDate.setHours(selectedDate.getHours() + 6);
            options.editorCallback(selectedDate);
        };
    
        return (
            <Calendar 
                value={options.value} 
                onChange={handleDateChange} 
                dateFormat="mm/dd/yy" 
                mask="99/99/9999" 
            />
        );
    };   

    const handleDataTableUpdate = (newData) => {
        setLastNewData(newData);
        if (dataToExport) {
            const filteredData = newData.map((item) => {
                const filteredItem = {
                    count: item.count
                };
                for (const col of visibleColumns) {
                  if (item.hasOwnProperty(col.field)) {
                    filteredItem[col.field] = item[col.field];
                  }
                }
                filteredItem.date_created = item.date_created;
                return filteredItem;
            });
            setDataToExport(filteredData);
        }
    };

    const formatTopMTR = (data) => {
        return data.map((item, index) => {
            if (item.file_name && item.file_name.includes("/")) {
                const fileNameParts = item.file_name.split("/");
                item.file_name = fileNameParts.pop();
            }
            if (item.description && item.description.includes("WT")) {
                const indexWT = item.description.indexOf(" WT");
                if (indexWT !== -1) {
                    const substringBeforeWT = item.description.substring(0, indexWT).trim();
                    const lastSpaceIndex = substringBeforeWT.lastIndexOf(" ");
                    const wallThickness = substringBeforeWT.substring(lastSpaceIndex + 1);
                    item.width = wallThickness;
                }
            }
            let parsedDate = null;
            if (item.date) {
                parsedDate = new Date(item.date);
                parsedDate.setHours(parsedDate.getHours() - 6);
            }
            else {
                parsedDate = null
            }
            
            let parsedDateM = new Date(item.created_at);       
            if (!isNaN(parsedDateM.getTime())) {
                parsedDateM.setHours(parsedDateM.getHours() - 6);
            } else {
                parsedDateM = null;
            }

            item.date_created = parsedDateM;
            item.date = parsedDate;
            delete item.created_at;
            delete item.updated_at;
            return item;
        });
    };

    const diameterRowFilterTemplate = (options) => {
        return (
            <MultiSelect
                value={options.value}
                options={diameters}
                itemTemplate={diameterItemTemplate}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder="Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
        );
    };

    const diameterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option}</span>
            </div>
        );
    };

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => {options.filterCallback(e.value, options.index)}} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />
    }

    const allowEdit = (rowData) => {
        return rowData.name !== 'Blue Band';
    };

    const tabviewStyle = {
        marginTop: '10px',
        maxWidth: 'calc(100vw - 100px)'
    };

    const onRowEditComplete = (e) => {
        let { newData } = e;
        updateItem(newData);
    };

    const updateItem = async (data) => {
        try {
            const token = sessionStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`,
            };
            const file_response = await api.put(`/mtr/update-mtr/${selectedDocId}/${data.id}`, data, { headers });
            const updatedFormattedAll = formattedAll.map(item =>
                item.id === data.id ? { ...item, ...data } : item
            );
            setFormattedAll(updatedFormattedAll);
            const file = await api.get(`/files/get-file/${file_response.data.file_id}`, { headers });
            const selectedStationMod = data.folder_name.replace(/%20/g, ' ');
            const requestBodyAct = {
                'type_id': 6,
                "project_id": parseInt(sessionStorage.getItem('selectedProjectId'),10),
                "description": `manually updated an attribute in file: ${file.data.file_name.split('/').pop()}`,
                "meta_data": {
                    "folder_id": file.data.folder_id,
                    "folder_name": selectedStationMod,
                    "doc_type": file.data.document_type_id,
                    "file_id": file.data.id,
                    "old_data": data,
                    "doc_type_name": selectedDocType
                }
            }
            const apiUrlAct = `/activity/add-activity`;
            await api.post(apiUrlAct, requestBodyAct, { headers });
            showMessage(toastBottomLeft, 'success', 'Success', 'Attribute change complete');
        } catch (error) {
            console.error('Failed to update item: ', error);
        }
    }

    const skelTemplate = () => {
        return (
            <Skeleton width='5rem'/>
        );
    };

    const fileTitleTemplate = (rowData) => {
        let name = '';
        if (rowData.file_name && rowData.file_name.includes('tmp')) {
            const parts = rowData.file_name.split('/');
            name = parts[parts.length - 1];
        } else {
            name = rowData.file_name;
        }
    
        const isUnverified = rowData.verified === false;
        const redStyle = { color: 'red' };
    
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <a
                    className="title-preview-link"
                    style={isUnverified ? redStyle : {}}
                    onClick={() => {
                        previewFile(name, rowData);
                        setPreviewFile(rowData);
                    }}
                >
                    {name}
                </a>
                {isUnverified && (
                    <i
                        className="pi pi-exclamation-circle"
                        style={redStyle}
                        title="This file is not verified"
                    />
                )}
            </div>
        );
    };

    const previewFile = async (name, data) => {
        try {
            const token = sessionStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };
            const response = await api.get(
                `/files/client/${sessionStorage.getItem("selectedClientId")}/project/${sessionStorage.getItem("selectedProjectId")}/file/${name}`,
                { headers }
            );
            const page = Number.isInteger(parseInt(data.pagenumber, 10)) && parseInt(data.pagenumber, 10) > 0 
                ? parseInt(data.pagenumber, 10) 
                : 1;
            setPreviewPageNum(page)
            setPreviewTableData(formatPreviewData(formattedAll, data.file_id));
            setPdfURL(response.data.pre_signed_url);
            setPreviewVisible(true);
        } catch (error) {
            console.error("Failed to preview file:", error);
        } 
        //finally {
        //   setLoading(false);
        // }
    };

    const formatPreviewData = (data, id) => {
        const grouped = {};
      
        data
          .filter(item => item.file_id === id)
          .forEach((item) => {
      
            const formattedAttributes = Object.entries(item)
                .filter(([key]) => !['pagenumber', 'id', 'file_id', 'verified'].includes(key))
                .map(([key, val]) => {
                        let formattedKey;

                        const keyMap = {
                        heatcode: 'Heat Code',
                        date: 'Date Manufactured',
                        seamtype: 'Seam Type',
                        ponumber: 'PO Number',
                        componenttype: 'Component Type',
                        width: 'Wall Thickness'
                    };

                    if (keyMap[key.toLowerCase()]) {
                        formattedKey = keyMap[key.toLowerCase()];
                    } else {
                    formattedKey = key
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, char => char.toUpperCase());
                    }

                    return {
                        attribute: formattedKey,
                        database_column: key,
                        value: val,
                        record_id: item.id
                    };
                });
      
            const page = item.pagenumber || 'Unknown';
      
            if (!grouped[page]) {
              grouped[page] = [];
            }
      
            grouped[page].push(...formattedAttributes);
          });
      
        return grouped;
    };  

    const prevHeaderElement = (
        <div>
            <p>
                <span style={{ color: '#043d75', fontWeight: 'bold' }}>
                    Preview File:
                </span>{' '}
                <span style={{ color: '#043d75' }}>{previewFileData.file_name}</span>{' '}
                <span
                style={{
                    color: previewFileData.verified ? 'green' : 'red',
                    fontWeight: 'bold',
                }}
                >
                    ({previewFileData.verified ? 'Verified' : 'Unverified'})
                </span>
            </p>
        </div>
    );

    const getDiams = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };
            const responseDiam = await api.get('/mtr/diameter', { headers });
            setDiams(responseDiam.data.map(item => item))
            setDiameters(responseDiam.data.map(item => item + '"'))
        } catch (error) {
            console.error("Failed to get diameters:", error);
        } 
    };

    const checkCompatibleDiam = (data) => {
        if (!data) return false;

        // Find the first key containing "diameter"
        const diameterKey = Object.keys(data).find((key) =>
            key.toLowerCase().includes("diameter")
        );

        if (!diameterKey) return false;

        const value = (data[diameterKey] || "").trim();

        // Return false if the value is blank or missing
        if (!value) return false;

        // Return true only if the value is not in statuses
        return !statuses.includes(value);
    };
  
    return (
        <div style={tabviewStyle} id='database-table'>
            {(isLoading ? (
                <DataTable showGridlines value={skelData}>
                    <Column header="File Name" body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                    <Column body={skelTemplate}/>
                </DataTable>
            ) : (
                visibleColumns.length > 0 && (
                    <DataTable scrollable className='database-table' showGridlines value={tableData} selectionMode='single' editMode="row" selection={selectedDBRow} paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} removableSort globalFilterFields={globalFilters} filters={globalFilterFields} emptyMessage="No items." onValueChange={handleDataTableUpdate} onRowEditComplete={onRowEditComplete} >
                        {visibleColumns.map((col) => (
                            col.field === "diameter" || col.field === 'pipe_diameter' ? (
                                <Column
                                    key={col.field}
                                    headerStyle={{ minWidth: "10rem" }}
                                    sortable
                                    filter
                                    header={col.header}
                                    field={col.field}
                                    showFilterMatchModes={false}
                                    filterElement={diameterRowFilterTemplate}
                                    editor={(options) => dropdownEditor(options)}
                                    body={(rowData) => (
                                        <span className='warning-attribute'>
                                            <p>{rowData[col.field]}</p>
                                            {checkCompatibleDiam(rowData) && (
                                                <i
                                                    className="pi pi-info-circle"
                                                    style={{ color: 'red', cursor: 'pointer' }}
                                                    title="This diameter is not one of the supported values required for PODS. Please select a different diameter."
                                                ></i>
                                            )}
                                        </span>
                                    )}
                                />
                            ) : col.field === "pagenumber" ? (
                                <Column key={col.field} headerStyle={{ minWidth: '11rem' }} sortable filter dataType="date" header="Page Number" field={col.field} filterField={col.field}></Column>
                            ) : col.field === "date_created" ? (
                                <Column key={col.field} headerStyle={{ minWidth: '11rem' }} sortable filter dataType="date" header="Date Created" filterElement={dateFilterTemplate} field="date_created" filterField="date_created" body={(rowData) => {
                                    return (
                                        <span>
                                            {rowData.date_created ? rowData.date_created.toLocaleDateString('en-US') : ''}
                                        </span>
                                    );
                                }}></Column>
                            ) : col.field === "date" ? (
                                <Column key={col.field} headerStyle={{ minWidth: '13rem' }} sortable filter dataType="date" header="Date Manufactured" filterElement={dateFilterTemplate} field="date" filterField="date" editor={(options) => dateEditor(options)} body={(rowData) => {
                                    return (
                                        <span>
                                            {rowData.date ? rowData.date.toLocaleDateString('en-US') : ''}
                                        </span>
                                    );
                                }}></Column>
                            ) : col.field === "file_name" ? (
                                <Column key={col.field} headerStyle={{ minWidth: '10rem' }} sortable filter field={col.field} filterField={col.field} header={col.header} editor={(options) => textEditor(options)} body={fileTitleTemplate}/>
                            ) : col.field === "folder_name" ? (
                                <Column key={col.field} headerStyle={{ minWidth: '11rem' }} sortable filter field={col.field} filterField={col.field} header={col.header}/>
                            ) : (
                                <Column key={col.field} headerStyle={{ minWidth: '12rem' }} sortable filter field={col.field} filterField={col.field} header={col.header} editor={(options) => textEditor(options)}/>
                            )
                        ))}
                        <Column header="Edit" rowEditor={allowEdit} headerStyle={{ minWidth: '5rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>
                )
            ))}
            <Dialog
                header={prevHeaderElement}
                style={{ height: '80vh', width: '70vw' }}
                maximizable
                draggable
                visible={previewVisible}
                onHide={() => {
                    setPreviewVisible(false);
                    setPdfButVis(false);
                }}
            >
                <PreviewFileWindow getDiams={getDiams} previewTableData={previewTableData} setPreviewData={setPreviewTableData} setPreviewFile={setPreviewFile} setPdfButVis={setPdfButVis} showMessage={showMessage} toastBottomLeft={toastBottomLeft} previewFileData={previewFileData} pdfUrl={pdfUrl} diams={statuses} previewPageNumber={previewPageNumber} attributeTableData={formattedAll} setAttributeTableData={setFormattedAll}/> 
            </Dialog>
            <Toast ref={toastBottomLeft} position="bottom-left" />
        </div>
    )
  };
  
  export default DatabaseView;